require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-lockenhaus.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-lockenhaus");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-lockenhaus!./.cache/json/betreuungseinrichtungen-oberpullendorf-lockenhaus.json
// module id = 980
// module chunks = 231608221292675